import React from "react";

import dayjs from "dayjs";
import { Edit } from "icons";

import { Button, Typography } from "clearsense-ui/components";

const ValueAccordion = ({ valueIndex, value, handleUpdateValue }) => (
  <div
    key={valueIndex}
    className="bg-gray-50 flex justify-between items-center border border-solid border-gray-300 w-full p-4 mb-2 dark:bg-gray-800 dark:bg-opacity-60 dark:border-gray-500"
  >
    <Typography type="bold">{value?.name}</Typography>
    <div className="flex items-center gap-10">
      <Typography className="text-gray-500">
        (Start Date: {dayjs(value.startDate).format("MMMM DD, YYYY")})
      </Typography>
      <Button
        style="text"
        icon={() => <Edit size="20" />}
        onClick={() => handleUpdateValue(valueIndex)}
      />
    </div>
  </div>
);

export default ValueAccordion;
